module.exports = __webpack_public_path__ + "static/media/vectorL.fd1dd75f.svg";